import React from "react";
import { Navigate, Outlet, RouteProps } from "react-router-dom";
import { RoutePermission } from "../../../models";
import UnauthorizedComponent from "../../pages/Page401.component";
import { AuthorizationResult } from "../config";
import useAuthorization from "../hooks/use-authorization.hook";

interface IPrivateRouteProps extends RouteProps {
  routePermission: RoutePermission;
}

const PrivateRoute: React.FC<IPrivateRouteProps> = ({ routePermission }) => {
  const authorization = useAuthorization(routePermission);

  if (authorization === AuthorizationResult.LoginRequired) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/" replace />;
  }

  if (authorization === AuthorizationResult.Unauthorized) {
    return <UnauthorizedComponent />;
  }

  return <Outlet />;
};

export default PrivateRoute;
